export default "assets/terroirs-map-9bcbdc9e.jpg";